/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const BatchEndpoint = {
  RootV1ChatCompletions: "/v1/chat/completions",
  RootV1Embeddings: "/v1/embeddings",
  RootV1ImagesGenerations: "/v1/images/generations",
} as const;
export type BatchEndpoint = ClosedEnum<typeof BatchEndpoint>;

/** @internal */
export const BatchEndpoint$inboundSchema: z.ZodNativeEnum<
  typeof BatchEndpoint
> = z.nativeEnum(BatchEndpoint);
/** @internal */
export const BatchEndpoint$outboundSchema: z.ZodNativeEnum<
  typeof BatchEndpoint
> = BatchEndpoint$inboundSchema;
